// An infinite query's next page: the one after the last page fetched, until its `meta` says it
// was the last.
export const nextPage = ({ meta }: { meta: { current_page: number; last_page: number } }) =>
  meta.current_page < meta.last_page ? meta.current_page + 1 : undefined
